export default {
  error_messages: {
    failed_to_fetch_orders: 'Falha ao carregar dados. Clique no ícone “atualizar” ou tente novamente em 1 minuto.',
    something_went_wrong: 'Algo correu mal, por favor tente novamente.',
  },
};
